// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useQuery, QueryHookOptions } from "@apollo/client";
import { activeBanner } from "../types/activeBanner";

export const useActiveBannerQuery = (
  opts: QueryHookOptions<activeBanner, {}>
) => {
  return useQuery<activeBanner, {}>(activeBannerQuery, {
    ...opts,
    context: { ...opts.context, products: true }
  });
};

export const activeBannerQuery = gql`
  query activeBanner {
    activeBanner {
      web {
        id
        text
        linkUrl
        linkLabel
        dismissable
        image {
          id
          responsiveImage {
            ...ResponsiveImageFragment
          }
        }
      }
    }
  }

  fragment ResponsiveImageFragment on ResponsiveImage {
    srcSet
    sizes
    src
    width
    height
    aspectRatio
    alt
    title
  }
`;

export function refetchActiveBannerQuery() {
  return {
    query: activeBannerQuery
  };
}
